const durationCache = new Map();

export const getVideoDurationAsync = ({ url }) => {
  if (!url) {
    return Promise.resolve(null);
  }

  if (durationCache.has(url)) {
    return Promise.resolve(durationCache.get(url));
  }

  return new Promise((resolve) => {
    const video = document.createElement("video");
    video.preload = "metadata";

    const cleanup = () => {
      video.onloadedmetadata = null;
      video.onerror = null;
      video.src = "";
    };

    video.onloadedmetadata = () => {
      const duration = Number.isFinite(video.duration) ? video.duration : null;
      durationCache.set(url, duration);
      cleanup();
      resolve(duration);
    };

    video.onerror = () => {
      durationCache.set(url, null);
      cleanup();
      resolve(null);
    };

    video.src = url;
  });
};

export const isVideoDurationInRange = ({
  duration,
  minSeconds,
  maxSeconds,
}) => {
  if (duration == null || !Number.isFinite(duration)) {
    return false;
  }

  return duration >= minSeconds && duration <= maxSeconds;
};
